export default "__VITE_ASSET__c43efb2b__"